module.exports = __webpack_public_path__ + "media/Fortress Xmas Dubstep.1418085a.mp3";